<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p32"><span><a id="page_25"></a><a href="#/Contents#rp32">FRAGRANT MUSHROOM SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>You’ll love this delicately flavored mushroom soup.</i></span></p>
<p class="make"><span>4 first-course servings</span></p>
<p class="hang"><span>1 pound mushrooms</span></p>
<p class="hang"><span>2 teaspoons margarine or butter</span></p>
<p class="hang"><span>1½ tablespoons flour</span></p>
<p class="hang"><span>1 quart Fragrant Beef Stock (see <a href="#/Chapter017#p7">p. 6</a>) or reduced-sodium beef broth</span></p>
<p class="hang"><span>1 tablespoon light soy sauce</span></p>
<p class="hang"><span>2 tablespoons dry sherry (optional)</span></p>
<p class="hang"><span>½ teaspoon lemon juice</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Slice 4 large mushroom caps and reserve. Chop remaining mushrooms and stems. Sauté chopped mushrooms in margarine in large saucepan until mushrooms are tender and juices are almost evaporated, about 8 minutes. Sprinkle with flour and cook 1 minute; add stock and soy sauce and heat to boiling. Reduce heat and simmer 5 minutes. Process soup in food processor or blender until smooth; return to saucepan and heat to simmering. Add sliced mushrooms and simmer, covered, 5 minutes; stir in sherry and lemon juice. Season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 86</span></p>
<p class="per1"><span>% calories from fat: 28</span></p>
<p class="per1"><span>Protein (g): 6</span></p>
<p class="per1"><span>Carbohydrate (g): 9.2</span></p>
<p class="per1"><span>Fat (g): 2.9</span></p>
<p class="per1"><span>Saturated fat (g): 0.7</span></p>
<p class="per1"><span>Cholesterol (mg): 3</span></p>
<p class="per1"><span>Sodium (mg): 245</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0214.vue?bfb54608